import { DateTime } from "luxon";
import { getLongDateFormat } from "../../utils/luxonHelpers";
import Shift from "./Shift";

const sortShifts = (shifts) => {
  if (!shifts) return [];
  return shifts.slice().sort((a, b) => {
    const aTime =
      a.start_time instanceof DateTime
        ? a.start_time
        : DateTime.fromISO(a.start_time);
    const bTime =
      b.start_time instanceof DateTime
        ? b.start_time
        : DateTime.fromISO(b.start_time);
    if (aTime < bTime) return -1;
    if (aTime > bTime) return 1;
    return 0;
  });
};

const Day = (props) => {
  const {
    shifts,
    event,
    memberTypeProperties,
    readOnly,
    topHourOffset,
    canSkipValidation,
    date,
  } = props;

  const shiftNodes = sortShifts(shifts).map((shift) => (
    <Shift
      key={shift.identifier}
      event={event}
      shift={shift}
      memberTypeProperties={memberTypeProperties}
      readOnly={readOnly}
      topHourOffset={topHourOffset}
      canSkipValidation={canSkipValidation}
    />
  ));

  const dateTime = date instanceof DateTime ? date : DateTime.fromISO(date);

  return (
    <div className="day">
      <div className="day--header">
        {dateTime.toFormat("cccc")}
        <br />
        {dateTime.toFormat(getLongDateFormat())}
      </div>
      <div className="shifts">{shiftNodes}</div>
    </div>
  );
};

export default Day;
